export default __webpack_public_path__ + "static/media/blueCheckHeart.cb73fc07.svg";